var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input",class:{ 'input--error': _vm.error },attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value || null)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }